import { Schema } from 'effect';

/**
 * Warehouse filter state schemas
 *
 * This module defines the internal state representation for warehouse stock filtering.
 * Warehouses are identified by literal codes and stored in a HashSet for efficient lookup.
 *
 * @module WarehouseFilterState
 */

/**
 * Literal warehouse codes.
 * Currently supports two warehouse locations: Pardubice and Chrudim.
 *
 * @remarks
 * This is a closed set - new warehouses require code changes.
 * Each code maps to a warehouse UUID in the configuration.
 *
 * @example
 * const warehouse: WarehouseCode = 'pardubice';
 */
export const WarehouseCode = Schema.Literals(['pardubice', 'chrudim']);

export type WarehouseCode = Schema.Schema.Type<typeof WarehouseCode>;

/**
 * HashSet of selected warehouse codes.
 * Represents the current filter state for warehouse stock availability.
 *
 * @example
 * const selectedWarehouses = HashSet.make<WarehouseCode>('pardubice', 'chrudim');
 */
export const WarehouseFilterStateSet = Schema.HashSet(WarehouseCode);

export type WarehouseFilterStateSet = Schema.Schema.Type<typeof WarehouseFilterStateSet>;
